import type { PropsWithChildren } from 'react'

import { type CheckboxProps } from '@material-ui/core/Checkbox/'

import { IconCheck, IconX } from '../Icon'
import { Space } from '../Space'
import { SubText } from '../Text'
import { CheckboxLabelStyled } from './styles/CheckboxLabelStyled'
import { CheckboxStyled } from './styles/CheckboxStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface ICheckboxProps extends CheckboxProps {
  /** Unique identifier for analytics tracking for checkbox interactions. */
  analyticsId?: string
}

export const Checkbox = (props: PropsWithChildren<ICheckboxProps>) => {
  const {
    children,
    checked = false,
    id,
    disabled,
    analyticsId,
    ...otherProps
  } = props
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  const baseCheckbox = (
    <Space size='small' direction='horizontal' align='baseline'>
      <CheckboxStyled
        id={id}
        disableRipple={true}
        color='default'
        icon={<></>}
        checkedIcon={<IconCheck />}
        indeterminateIcon={<IconX />}
        aria-checked={checked}
        checked={checked}
        disabled={disabled}
        {...analyticsProps}
        {...otherProps}
      />
      {children && <SubText>{children}</SubText>}
    </Space>
  )

  if (id) {
    return (
      <CheckboxLabelStyled htmlFor={id} disabled={disabled}>
        {baseCheckbox}
      </CheckboxLabelStyled>
    )
  }

  return baseCheckbox
}
Checkbox.displayName = 'Checkbox'
